import { render } from "./MyPageNon2.vue?vue&type=template&id=3f29c480&scoped=true&ts=true"
import script from "./MyPageNon2.vue?vue&type=script&lang=ts"
export * from "./MyPageNon2.vue?vue&type=script&lang=ts"

import "./MyPageNon2.vue?vue&type=style&index=0&id=3f29c480&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f29c480"]])

export default __exports__